/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import Changelog from 'ui/components/Changelog.vue';
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import PackageButton from 'ui/components/PackageButton.vue';
import PackageDetails from 'ui/components/PackageDetails.vue';
import UninstallPackageButton from 'ui/components/UninstallPackageButton.vue';
import ModalShowcase from 'ui/components/modals/Showcase.vue';

/**
 * This component is the main Marketplace details page controller.
 *
 * @vue-prop {Object} params the page configuration parameters.
 *
 * @category ui.components
 * @exports PackageDetails
 * @component
 */
const __vue_script__ = {
    name: 'PackageDetails',

    components: {
        Badge,
        Changelog,
        DropdownMenu,
        PackageButton,
        PackageDetails,
        UninstallPackageButton,
        ModalShowcase,
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            loading: true,
            module: { package: {} },
            categories: null,
            media: null,
            badgeConfig: {},
            installed: false,
            canUninstall: false,
            eventId: this.params.event.id,
            orgId: this.params.event.ownerId,
            marketplaceLink: `/event/${this.params.event._id}/marketplace`
        };
    },

    async created() {
        const pkg = await this.$services.market.getPackageDetails(this.params.pkgName, this.eventId);

        this.module = pkg;
        this.media = pkg.images.filter(m => m !== null);
        this.categories = pkg.categories
            .map(cat => this.$i18n.t(`marketplace.categories.${cat}`))
            .join(', ');

        this.installed = this.module.installed;
        this.canUninstall = this.module.can_be_uninstalled;
        this.loading = false;

        const paid = !!this.module.paid;

        if (this.$services.user.isApiDeveloper()) {
            this.module.api_page_url = this.$utils.url.getDeveloperDocURL({
                pkgName: pkg.name,
                version: pkg.version
            });
        }

        this.badgeConfig = {
            classes: [paid ? 'warn' : 'success'],
            text: `marketplace.${paid ? 'paid' : 'free'}_module`
        };
    },

    methods: {
        showChangelog() {
            this.$modal.show(Changelog, {
                name: this.module.name
            }, {
                height: 'auto',
                scrollable: true,
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-showcase',{staticClass:"package-details",attrs:{"media":_vm.media,"close":function () { return _vm.$emit('close'); },"loading":_vm.loading},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"actions"},[_c('PackageButton',{attrs:{"module":_vm.module,"eventId":_vm.eventId,"orgId":_vm.orgId,"context":"details-page"}}),(_vm.installed && _vm.canUninstall)?_c('DropdownMenu',[_c('ul',[(_vm.module.installed)?_c('li',[_c('UninstallPackageButton',{attrs:{"module":_vm.module,"eventId":_vm.eventId,"orgId":_vm.orgId,"context":"details-page"}})],1):_vm._e()])]):_vm._e()],1),_c('h1',[_vm._v(_vm._s(_vm.module.title)),(_vm.module.deprecated)?_c('badge',[_vm._v(_vm._s(_vm.$t('marketplace.package.deprecated')))]):_vm._e(),(!_vm.installed && !_vm.module.deprecated)?_c('badge',{attrs:{"config":_vm.badgeConfig}},[_vm._v(_vm._s(_vm.$t(_vm.badgeConfig.text)))]):_vm._e()],1),_c('p',{staticClass:"subtitle"},[(_vm.module.api_page_url)?_c('span',{staticClass:"dev-link"},[_c('a',{attrs:{"href":_vm.module.api_page_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('marketplace.package.see_api_doc')))]),_c('br')]):_vm._e(),_c('span',{staticClass:"categories"},[_vm._v(_vm._s(_vm.categories))]),_c('br'),_c('small',[_vm._v("v"+_vm._s(_vm.module.package.version))])])]},proxy:true},{key:"main_details",fn:function(){return [_c('header',[_c('h4',[(_vm.module.description_url)?_c('span',{staticClass:"opposite"},[_c('a',{attrs:{"href":_vm.module.description_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('marketplace.package.see_doc')))])]):_vm._e(),_vm._v(_vm._s(_vm.$t('general.description')))])]),_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.module.description)}})]},proxy:true},{key:"side_details",fn:function(){return [_c('div',{staticClass:"changelog"},[_c('header',[_c('h4',[_c('span',{staticClass:"opposite"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.showChangelog()}}},[_vm._v(_vm._s(_vm.$t('marketplace.package.all_changelogs')))])]),_vm._v(_vm._s(_vm.$t('marketplace.package.changelog')))])]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"version"},[(_vm.module.published)?_c('span',{staticClass:"opposite"},[_vm._v(_vm._s(_vm.$utils.time.timeFromNow(_vm.module.published)))]):_vm._e(),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.module.version))])]),_c('div',{staticClass:"log",domProps:{"innerHTML":_vm._s(_vm.module.changelog)}})])]),(_vm.module.dependencies)?_c('div',{staticClass:"dependencies"},[_c('h4',[_vm._v(_vm._s(_vm.$t('marketplace.package.dependencies')))])]):_vm._e()]},proxy:true}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PackageDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__